<template>
  <div>
    <v-card class="pt-3 pb-5 px-3">
      <div class="d-flex align-center justify-space-between mb-3">
        <h4 class="text-uppercase">
          {{ $vuetify.lang.t(`$vuetify.labels.payment`) }}
        </h4>
      </div>

      <p class="mb-0" v-if="order.payment">
        {{ order.payment.name | multilingual(formLanguage) }}
      </p>
      <p v-else>-</p>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getOrder: 'orders/getOrder',
      formLanguage: 'languages/formLanguage',
    }),

    order() {
      return this.getOrder(Number(this.$route.params.id));
    },
  },
};
</script>

<style lang="scss" scoped></style>
